/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { AccessGateScreen, SafetyScreen, HardStopScreen, PainLocationScreen, CPGQuestionScreen, SubtypeQuestioningScreen, SelfAssessmentScreen, PreNprScreen, TestIntroScreen, HowChallengingScreen, FeelAffectScreen, TestIntroTwo, Feedback2, PlanRecommendation, RecoveryScoreScreen, ScreenPlan, InvalidCodeScreen, FloorCapabilityScreen, IntroAR, ProblemAreaScreen, SafetyScreeningScreen, PdfViewerPage, BackConfirmModal, SelfReportQuestionsScreen } from "./SelfAssesment";
import { LandingPage } from "../virdioHealth/LandingPage";
import { AboutUs } from "../virdioHealth/About";
import { ContactUs } from "../virdioHealth/ContactUs";
import Register from "../register/register";
import Verify from "../register/verify";
import { useHistory, useLocation } from "react-router-dom";
import { HomeScreen } from "./LandingPage";
import { AskMyraPage } from "../pages/AskMyra";
import { HowItWorksPage } from "../pages/HowItWorks";
import { AboutVirdioPage } from "../pages/AboutVirdio";
const isVirdioDomain = ["virdiohealth.com", "www.virdiohealth.com"].includes(window.location.host);

// eslint-disable-next-line no-unused-vars
const useDisableBackButton = () => {
  useEffect(() => {
    const blockBack = () => {
      window.history.pushState(null, "", window.location.href);
      if (window.mayraCode) {
        window.mayraCode.setIsVisible(false);
        window.mayraCode.forceStop();
      }
    };

    // Wipe any history entry behind and lock this one
    window.history.pushState(null, "", window.location.href);

    // Listen for any back/forward attempts
    window.addEventListener("popstate", blockBack);
    return () => {
      window.removeEventListener("popstate", blockBack);
      if (window.mayraCode) {
        window.mayraCode.setIsVisible(false);
        window.mayraCode.forceStop();
      }
    };
  }, []);
};

export function useBackButtonGuard() {
  const history = useHistory();
  const location = useLocation();
  const [showBackModal, setShowBackModal] = useState(false);
  const unblockRef = useRef(null);
  const savedPathRef = useRef(location.pathname);
  const isRestoringRef = useRef(false);

  const registerBlock = () => {
    if (unblockRef.current) {
      unblockRef.current();
    }

    unblockRef.current = history.block((nextLocation, action) => {
      if (isRestoringRef.current) return;

      if (action === "POP") {
        if (location.pathname === "/") return;

        savedPathRef.current = location.pathname;
        setShowBackModal(true);
        return false;
      }
    });
  };

  useEffect(() => {
    if (!isRestoringRef.current) {
      savedPathRef.current = location.pathname;
    }
    registerBlock();

    return () => {
      if (unblockRef.current) {
        unblockRef.current();
      }
    };
  }, [history, location]);

  const confirmLeave = () => {
    setShowBackModal(false);

    if (window.mayraCode) {
      window.mayraCode.setIsVisible(false);
      window.mayraCode.forceStop();
    }

    if (unblockRef.current) {
      unblockRef.current();
      unblockRef.current = null;
    }

    history.replace("/");
  };

  const cancelLeave = () => {
    setShowBackModal(false);

    if (history.location.pathname !== savedPathRef.current) {
      isRestoringRef.current = true;

      history.replace(savedPathRef.current);

      setTimeout(() => {
        isRestoringRef.current = false;
        registerBlock();
      }, 100);
    } else {
      registerBlock();
    }
  };

  return { showBackModal, confirmLeave, cancelLeave };
}
function AppRoutesInner() {
  const searchParams = new URLSearchParams(window.location.search);
  const hasAfter = searchParams.has("after") && localStorage.getItem("runStep") !== "2" ? true : false;
  const hasSecondTest = searchParams.has("after") && localStorage.getItem("runStep") === "2" ? true : false;
  const isNoCameraExerciseStage = localStorage.getItem("noCameraMode") === "true";
  console.log("isNoCameraExerciseStage", isNoCameraExerciseStage);
  const shouldRouteToSelfReport = hasAfter && isNoCameraExerciseStage;
  if (hasAfter) {
    window.initFromUserGesture();
  }
  const { showBackModal, confirmLeave, cancelLeave } = useBackButtonGuard();
  return (
    <>
      {/* Modal rendered once — protects all screens */}
      {showBackModal && (
        <BackConfirmModal
          onConfirm={confirmLeave}
          onCancel={cancelLeave}
        />
      )}

      <Switch>
        <Route path="/" exact render={(props) => {
          const params = new URLSearchParams(props.location.search);
          const file = params.get("file");

          if (file) {
            return <PdfViewerPage url={decodeURIComponent(file)} />;
          }

          return (shouldRouteToSelfReport ? <SelfReportQuestionsScreen /> : hasAfter ? <HowChallengingScreen /> : hasSecondTest ? <Feedback2 /> : isVirdioDomain ? <LandingPage /> : <HomeScreen />)
        }} />
        <Route path="/index.html" render={() => (shouldRouteToSelfReport ? <SelfReportQuestionsScreen /> : hasAfter ? <HowChallengingScreen /> : hasSecondTest ? <Feedback2 /> : isVirdioDomain ? <LandingPage /> : <HomeScreen />)} />
        {/* the rest stay the same */}

        <Route path="/virdiohealth" component={LandingPage} />
        <Route path="/ask-myra" component={AskMyraPage} />
        <Route path="/how-it-works" component={HowItWorksPage} />
        <Route path="/about" component={AboutVirdioPage} />
        <Route path={`/about-us`} component={AboutUs} />
        <Route path={`/contact-us`} component={ContactUs} />
        <Route path="/access-gate" component={AccessGateScreen} />
        <Route path="/red-flags" component={SafetyScreen} />
        <Route path="/register" component={Register} />
        <Route path="/verify-otp" component={Verify} />
        <Route path="/invalid-code" component={InvalidCodeScreen} />
        <Route path="/hard-stop" component={HardStopScreen} />
        <Route path="/problem-area" component={ProblemAreaScreen} />
        <Route path="/pain-location" component={PainLocationScreen} />
        <Route path="/safety-screening" component={SafetyScreeningScreen} />
        <Route path="/cpg-questions" component={CPGQuestionScreen} />
        <Route path="/subtype-questioning" component={SubtypeQuestioningScreen} />
        <Route path="/self-assesment" component={SelfAssessmentScreen} />
        <Route path="/pre-npr" component={PreNprScreen} />
        <Route path="/floor-capability" component={FloorCapabilityScreen} />
        <Route path="/intro-ar" component={IntroAR} />
        <Route path="/test-intro" component={TestIntroScreen} />
        <Route path="/self-report-questions" component={SelfReportQuestionsScreen} />
        <Route path="/how-challenging" component={HowChallengingScreen} />
        <Route path="/feel-affect" component={FeelAffectScreen} />
        <Route path="/test-intro-2" component={TestIntroTwo} />
        <Route path="/feedback-2" component={Feedback2} />
        <Route path="/plan-recommendation" component={PlanRecommendation} />
        <Route path="/recovery-score" component={RecoveryScoreScreen} />
        <Route path="/screen-plan" component={ScreenPlan} />
        <Route path="/pdf-viewer" component={PdfViewerPage} />
      </Switch>
    </>
  );
}
export default function AppRoutes() {
  return (
    <Router>
      <AppRoutesInner />
    </Router>
  );
}
